export { readAvatarCacheBuster, withAvatarCacheBust, writeAvatarCacheBuster } from "~services/avatar/avatarCacheBuster";
export { type AvatarEntityType } from "~services/avatar/avatarEntityTypes";
export { getAvatarUrl } from "~services/avatar/getAvatarUrl";
export {
  fullyQualifiedUrl,
  getBubblePictureIdFromAvatarUri,
  type ImageResourceType,
  makeAvatarUrl,
  makeBubbleAvatarUrl,
  makeEventAvatarUrl,
  makeImageResourceAvatarUrl,
  makeOrganizationAvatarUrl,
  makeProfileAvatarUrl,
  makeRoomAvatarUrl,
} from "~services/avatar/makeAvatarUrl";

import { readAvatarCacheBuster, withAvatarCacheBust, writeAvatarCacheBuster } from "~services/avatar/avatarCacheBuster";

export const readBubbleAvatarCacheBuster = (bubbleId: string) => readAvatarCacheBuster("bubble", bubbleId);
export const writeBubbleAvatarCacheBuster = (bubbleId: string, timestamp: number | string) =>
  writeAvatarCacheBuster("bubble", bubbleId, timestamp);
export const withBubbleAvatarCacheBust = (avatarUri: string, bubbleId: string, timestamp?: number | string) =>
  withAvatarCacheBust("bubble", avatarUri, bubbleId, timestamp);

export const readOrganizationAvatarCacheBuster = (organizationId: string) =>
  readAvatarCacheBuster("organization", organizationId);
export const writeOrganizationAvatarCacheBuster = (organizationId: string, timestamp: number | string) =>
  writeAvatarCacheBuster("organization", organizationId, timestamp);
export const withOrganizationAvatarCacheBust = (
  avatarUri: string,
  organizationId: string,
  timestamp?: number | string,
) => withAvatarCacheBust("organization", avatarUri, organizationId, timestamp);

export const readProfileAvatarCacheBuster = (userId: string) => readAvatarCacheBuster("profile", userId);
export const writeProfileAvatarCacheBuster = (userId: string, timestamp: number | string) =>
  writeAvatarCacheBuster("profile", userId, timestamp);
export const withProfileAvatarCacheBust = (avatarUri: string, userId: string, timestamp?: number | string) =>
  withAvatarCacheBust("profile", avatarUri, userId, timestamp);

export const readRoomAvatarCacheBuster = (roomId: string) => readAvatarCacheBuster("room", roomId);
export const writeRoomAvatarCacheBuster = (roomId: string, timestamp: number | string) =>
  writeAvatarCacheBuster("room", roomId, timestamp);
export const withRoomAvatarCacheBust = (avatarUri: string, roomId: string, timestamp?: number | string) =>
  withAvatarCacheBust("room", avatarUri, roomId, timestamp);

export const readEventAvatarCacheBuster = (eventId: string) => readAvatarCacheBuster("event", eventId);
export const writeEventAvatarCacheBuster = (eventId: string, timestamp: number | string) =>
  writeAvatarCacheBuster("event", eventId, timestamp);
export const withEventAvatarCacheBust = (avatarUri: string, eventId: string, timestamp?: number | string) =>
  withAvatarCacheBust("event", avatarUri, eventId, timestamp);

/** @deprecated use fullyQualifiedUrl and `services/router/Route` */
export const makeRoomUrl = (roomId: string): string => {
  if (window.location.href) {
    const url = new URL(window.location.href);
    url.pathname = `/rooms/${roomId}`;
    return url.href;
  }
  throw new Error("please define REACT_APP_BACKEND_URL");
};

/** sleeps for the given amount of time */
export const sleep = (delayMillis: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, delayMillis);
  });

/** retry an async operation with delays */
export const withRetries = async (callback: () => Promise<void>, retries = 5, delayMillis = 1000): Promise<boolean> => {
  let lastError: unknown;

  for (let i = 0; i < retries; i++) {
    try {
      await callback();
      return true;
    } catch (err) {
      lastError = err;
      if (i < retries - 1) {
        await sleep(delayMillis);
      }
    }
  }

  console.warn("unexpected error", lastError);
  return false;
};

/** is the given token expired? */
export const isTokenExpired = (token: string): boolean => {
  try {
    const exp = new Date(JSON.parse(atob(token.split(".")[1])).exp * 1000);
    return new Date() > exp;
  } catch {
    return true;
  }
};

export const isValidUrl = (url: string): boolean => {
  try {
    new URL(url);
  } catch {
    return false;
  }

  return true;
};
